import { createContext, useContext } from "react";

interface Props {
  caseId: string;
  generatePresignedUrlEndpoint: string;
  downloadUrl?: string;
}

export const ApplicationFormContext = createContext<Props>({
  caseId: "",
  generatePresignedUrlEndpoint: "",
  downloadUrl: "",
});

export function useApplicationFormContext() {
  return useContext(ApplicationFormContext);
}
